import { useEffect, useMemo } from 'react'
import { shallowEqual, useSelector, useDispatch } from 'react-redux'

import { IMPORT_HISTORY_TYPE } from 'api/import_history/constants'

import { getDailyReportsImportSettingsList, selectDailyReportsStatus } from 'slices/dailyReportsSlice'

import { CustomImportHistory } from 'components/common'

export const DailyReportHistory = () => {
  const dispatch = useDispatch()
  const { dailyReportsImportSettingsList } = useSelector(selectDailyReportsStatus, shallowEqual)

  useEffect(() => {
    dispatch(getDailyReportsImportSettingsList())
  }, [dispatch])

  const categories = useMemo(
    () =>
      dailyReportsImportSettingsList.map(({ id, name }) => ({
        key: id,
        label: name,
        value: IMPORT_HISTORY_TYPE.DAILY_REPORT,
      })),
    [dailyReportsImportSettingsList]
  )

  return <CustomImportHistory importHistoryType={IMPORT_HISTORY_TYPE.DAILY_REPORT} categories={categories} />
}
